import * as React from "react";
import type { SVGProps } from "react";
const SvgPlayground = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 18c-3.31 0-6-2.69-6-6 0-.55-.45-1-1-1h-2V7c0-.27-.11-.52-.29-.71l-4-4a.996.996 0 0 0-1.41 0l-4.01 4A.99.99 0 0 0 2 7v14c0 .55.45 1 1 1s1-.45 1-1v-8h2v8c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-8h1.07A8.002 8.002 0 0 0 20 19.93V21c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1ZM8 16h2v1H8v-1Zm0 3h2v1H8v-1ZM4 7.41l3-3 3 3V11H4V7.41ZM10 13v1H8v-1h2Z"
    />
  </svg>
);
export default SvgPlayground;
